import { useNavigate } from "react-router-dom";

export const ProgressTableCard = ({ title, quests = [] }) => {
const navigate = useNavigate();

  const handleQuestResume = (quest) => {
    navigate(`/student/admin/episodes/${quest}`)
  };

  return (
    <div className="col-md-12">
      {/* TABLE TITLE */}
      <div className="px-4 py-3 ProgressLesnTitl">{title}</div>

      <div
        className="bg-white"
        style={{
          borderRadius: "22px",
          border: "1px solid #e6e6e6",
          borderBottom: "none",
        }}
      >
        <div className="table-responsive">
          <table
            className="table table-hover tchrtabl-pdng"
            style={{ margin: "0px" }}
          >
            <thead className="progress-tablehead">
              <tr>
                <th className="fw-semibold">Quest</th>
                <th className="fw-semibold text-center">Episodes</th>
                <th className="fw-semibold text-center">Percentage</th>
                <th className="fw-semibold text-center">Resume</th>
              </tr>
            </thead>

            <tbody className="tchrtablbody">
              {quests.length > 0 ? (
                quests.map((quest) => (
                  <tr key={quest.quest_id}>
                    <td>{quest.quest_name}</td>

                    <td className="text-center">
                      {quest.episodes || "Pending"}
                    </td>

                    <td className="text-center">{quest.percentage}%</td>

                    <td className="text-center">
                      {quest.can_resume ? (
                        <button
                          onClick={() => handleQuestResume(quest.quest_id)}
                          className="btn p-0"
                          style={{
                            width: "28px",
                            height: "28px",
                            borderRadius: "50%",
                            background: "#1e88ff",
                            color: "#fff",
                            fontSize: "14px",
                          }}
                        >
                          ▶
                        </button>
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4">
                    No quests found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
